import React from "react";
import { Grid, MenuItem, TextField, Typography } from "@mui/material";
import Input from "../../../../../../components/Input";
import {
  OperationsDetailField,
  OperationsDetailGrid,
} from "../../../../ifas/components/OperationsUI";

const SOUTH_AFRICA_PROVINCES = [
  "Gauteng",
  "Western Cape",
  "KwaZulu-Natal",
  "Eastern Cape",
  "Free State",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
];

export default function BodyLocation({
  bodyLocationData,
  isEditable = false,
  formData,
  onChange,
  mortuaryName,
  onMortuaryChange,
  mortuaryOptions = [],
}: any) {
  const inputBackgroundColor = isEditable ? "#FFFFFF" : "background.paper";
  const value = (field: string) =>
    isEditable ? formData?.[field] || "" : bodyLocationData?.[field] || "";

  if (bodyLocationData && !isEditable) {
    return (
      <OperationsDetailGrid>
        <OperationsDetailField label="Mortuary Name" value={mortuaryName} />
        <OperationsDetailField
          label="House Number"
          value={value("houseNumber")}
        />
        <OperationsDetailField label="Street Name" value={value("streetName")} />
        <OperationsDetailField label="City" value={value("city")} />
        <OperationsDetailField label="Postal Code" value={value("postalCode")} />
        <OperationsDetailField label="Suburb" value={value("suburb")} />
        <OperationsDetailField label="Province" value={value("province")} />
        <OperationsDetailField label="Notes / Remarks" value={value("notes")} span={3} />
      </OperationsDetailGrid>
    );
  }

  return (
    <>
      {bodyLocationData ? (
        <Grid
          container
          rowSpacing={5}
          columnSpacing={10}
          mt={1}
          textAlign="left"
          p={3}
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              select
              disabled={!isEditable}
              value={mortuaryName || ""}
              onChange={(e: any) => onMortuaryChange?.(e.target.value)}
              height={40}
              width="100%"
              label="Mortuary Name*"
              backgroundColor={inputBackgroundColor}
            >
              <MenuItem value=""><em>Select mortuary</em></MenuItem>
              {mortuaryOptions.map((option: any) => (
                <MenuItem key={`mortuary-${option.id || option.externalBranchId || option.branchName}`} value={option.branchName}>
                  {option.branchName}
                </MenuItem>
              ))}
            </Input>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              disabled={!isEditable}
              value={value("houseNumber")}
              onChange={(e: any) => onChange?.({ houseNumber: e.target.value })}
              height={40}
              width="100%"
              label="House Number"
              backgroundColor={inputBackgroundColor}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              disabled={!isEditable}
              value={value("streetName")}
              onChange={(e: any) => onChange?.({ streetName: e.target.value })}
              height={40}
              width="100%"
              label="Street Name"
              backgroundColor={inputBackgroundColor}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              disabled={!isEditable}
              value={value("city")}
              onChange={(e: any) => onChange?.({ city: e.target.value })}
              height={40}
              width="100%"
              label="City"
              backgroundColor={inputBackgroundColor}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              disabled={!isEditable}
              value={value("postalCode")}
              onChange={(e: any) => onChange?.({ postalCode: e.target.value })}
              height={40}
              width="100%"
              label="Postal Code"
              backgroundColor={inputBackgroundColor}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              disabled={!isEditable}
              value={value("suburb")}
              onChange={(e: any) => onChange?.({ suburb: e.target.value })}
              height={40}
              width="100%"
              label="Subrub"
              backgroundColor={inputBackgroundColor}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              select
              disabled={!isEditable}
              value={value("province")}
              onChange={(e: any) => onChange?.({ province: e.target.value })}
              height={40}
              width="100%"
              label="Province"
              backgroundColor={inputBackgroundColor}
            >
              {SOUTH_AFRICA_PROVINCES.map((province) => (
                <MenuItem key={province} value={province}>
                  {province}
                </MenuItem>
              ))}
            </Input>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Typography fontSize={18} fontWeight={600} textAlign="left">
              Notes / Remarks *
            </Typography>
            <TextField
              multiline
              rows={5}
              fullWidth
              disabled={!isEditable}
              value={value("notes")}
              onChange={(e: any) => onChange?.({ notes: e.target.value })}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: inputBackgroundColor,
                },
              }}
            />
          </Grid>

          {/* {comments?.length > 0 && (
        <Grid size={12} mt={3}>
          {comments.map((comment: any, index: number) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "#F7F7F7",
                boxShadow: "none",
                borderRadius: "6px",
                mb: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {comment.commentedByName}{" "}
                    <Typography
                      component="span"
                      fontWeight={600}
                      color="#EC6E00"
                    >
                      - {comment.role_at_time_of_comment?.replace(/_/g, " ").toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {new Date(comment.created_on).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                    })}{" "}
                    | {formatDate(comment.created_on)}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography fontSize={15} color="#333" lineHeight={1.6}>
                  {comment.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      )}
      {isAssigned && claimStatus !== "PAID" && (
        <Grid size={{ md: 12 }} mt={3}>
          <Typography
            variant="body1"
            fontWeight={600}
            fontSize={18}
            sx={{ display: "block", textAlign: "left" }}
          >
            Comment
          </Typography>
          <TextField
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            disabled={isEditable}
            value={policyComment}
            onChange={onPolicyCommentChange}
          />
        </Grid>
      )}
      <Dialog
        open={openPreview}
        onClose={handleClosePreview}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Document Preview</DialogTitle>
        <DialogContent dividers>
          {selectedDoc ? (
            <object
              data={selectedDoc.file_url}
              type="application/pdf"
              width="100%"
              height="600px"
            >
              <p>
                PDF preview is not supported in this browser.{" "}
                <a
                  href={selectedDoc.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download PDF
                </a>
              </p>
            </object>
          ) : (
            <Typography>Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDownload(selectedDoc)}
            color="primary"
            variant="outlined"
          >
            Download
          </Button>

          <Button
            onClick={handleClosePreview}
            color="secondary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog> */}
        </Grid>
      ) : (
        <Typography>Body Location is not available</Typography>
      )}
    </>
  );
}
